export interface SearchState {
  basicSearch: string;
  branches: any[];
  locationsFrom: any[];
  locationsTo: any[];
  customers: any[];
  suppliers:any[]
}

export const initState: SearchState = {
    basicSearch: "",
    branches: [],
    locationsFrom: [],
    locationsTo: [],
    customers: [],
    suppliers: []
};